import React from 'react'
import i18n from 'simple-react-i18n'
import { Box, Grid } from '@mui/material'
import PropTypes from 'prop-types'
import AddPiezoStepOptionsAdes from './AddPiezoStepOptionsAdes'
import AddPiezoStepOptionsEmpty from './AddPiezoStepOptionsEmpty'
import { PIEZO_IMPORT_TYPE } from '../AddPiezoConstants'


const AddPiezoStepOptions = (props) => {
    const getOptionsPanel = () => {
        switch (props.station.stationType) {
            default: case PIEZO_IMPORT_TYPE.ADES_PIEZO:
                return <AddPiezoStepOptionsAdes {...props}/>
            case PIEZO_IMPORT_TYPE.EMPTY:
                return <AddPiezoStepOptionsEmpty {...props}/>
        }
    }
    return (
        <Box paddingTop={1}>
            <Grid container justifyContent='center' alignItems='center' spacing={3}>
                <h4>{i18n.newStationStep2}</h4>
            </Grid>
            { getOptionsPanel() }
        </Box>
    )
}

AddPiezoStepOptions.propTypes = {
    station: PropTypes.shape({
        stationType: PropTypes.string,
    }),
}

export default AddPiezoStepOptions